var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppstoreReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.appstore{fill:url(#appstore-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "appstore-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29781,
    stopColor: "#10aeeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#1779df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0132a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "appstore",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M72.21181,55.25609h-8.21609l-9.08357-15.79831-2.69208,1.63278,3.75685-6.534,1.21951-2.12094c.93414-1.62464.37437-3.69895-1.25027-4.63309s-3.69895-.37431-4.63303,1.25033l-1.19175,2.07272-1.19175-2.07272c-.93414-1.62464-3.00845-2.18447-4.63309-1.25033s-2.18441,3.00845-1.25027,4.63309l3.16091,5.4975-9.96016,17.32292h-8.4588c-1.87407,0-3.39328,1.51926-3.39328,3.39328s1.51921,3.39328,3.39328,3.39328h4.55671l-3.1749,5.52184c-.93414,1.62464-.37437,3.6989,1.25027,4.63303h.00006c1.62464.93414,3.6989.37431,4.63303-1.25027l4.16699-7.24732-4.68211-1.65729h23.79698l-.19614-3.35728,1.93037,3.35728.65218,1.13426.95319,1.6578,3.51453,6.11255c.93408,1.62459,3.00839,2.18441,4.63303,1.25027s2.18441-3.00839,1.25027-4.63303l-3.1749-5.52184h4.31405c1.87407,0,3.39328-1.51921,3.39328-3.39328s-1.51921-3.39322-3.39328-3.39322ZM56.67498,50.28725l-2.38322,2.58266.40997,3.49019c.08957.76256-.69011,1.32909-1.38773,1.00824l-3.1927-1.46837-3.19265,1.46837c-.69756.32086-1.4773-.24568-1.38773-1.00824l.40997-3.49019-2.38317-2.58266c-.52064-.56426-.22281-1.48088.53014-1.63135l3.446-.68863,1.71984-3.06458c.37574-.66952,1.3395-.66952,1.71529,0l1.71979,3.06458,3.44606.68863c.75295.15048,1.05072,1.0671.53014,1.63135Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreReviewsScraper);
export default __webpack_public_path__ + "static/media/appstore-reviews-scraper.3940a6b7e2136a6ad8a156f24a399333.svg";
export { ForwardRef as ReactComponent };